import { DocumentTypeWithVirtual, ValueOf } from 'support/types';

const documentTypesWithSummary: Array<ValueOf<DocumentTypeWithVirtual>> = [
  DocumentTypeWithVirtual.orderResponse,
  DocumentTypeWithVirtual.orderRejection,
  DocumentTypeWithVirtual.orderConfirmation,
  DocumentTypeWithVirtual.partialOrderConfirmation,
  DocumentTypeWithVirtual.order,
  DocumentTypeWithVirtual.dispatchInstruction,
  DocumentTypeWithVirtual.dispatchResponse,
  DocumentTypeWithVirtual.shippingNotice,
  DocumentTypeWithVirtual.invoice,
  DocumentTypeWithVirtual.creditNote,
  DocumentTypeWithVirtual.productCatalog,
  DocumentTypeWithVirtual.remittanceAdvice,
  DocumentTypeWithVirtual.debitNote,
  DocumentTypeWithVirtual.serviceInvoice,
  DocumentTypeWithVirtual.salesReport,
];

export const hasSummary = (documentType: ValueOf<DocumentTypeWithVirtual> | undefined): boolean => {
  if (!documentType) {
    return false;
  }
  return documentTypesWithSummary.includes(documentType);
};
